import type { Owner } from '@/modules/accounts/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function getTokenInfo(token: string): Promise<string> {
  const response = await apiClient.get(`/check-token/${token}`)

  return (response.data as { status: string }).status
}

async function getCurrentOwner(): Promise<Owner> {
  const response = await apiClient.get('/owner')

  return response.data
}

export const accountService = {
  getCurrentOwner,
  getTokenInfo,
}
